import { Component, Vue } from 'vue-property-decorator';
import categoryFourthLevelModule from '@/store/modules/category-fourth-level.module'
import { CategoryFourthLevel } from '@/shared/dtos/category-fourth-level';
import DxDataGrid, { DxLookup, DxSelection, DxPaging, DxHeaderFilter, DxEditing, DxColumn, DxFilterRow, DxFilterPanel, DxExport, DxColumnChooser } from 'devextreme-vue/data-grid';
import categoryThirdLevelModule from '@/store/modules/category-third-level.module';
import { itiMessageService } from '@/iti-core-vue';



@Component({
    components: {
        DxDataGrid,
        DxSelection,
        DxPaging,
        DxHeaderFilter,
        DxEditing,
        DxColumn,
        DxFilterRow,
        DxFilterPanel,
        DxExport,
        DxColumnChooser,
        DxLookup
    },
})

export default class CategoryFourthLevelLista extends Vue {

    public pageSize: number = 15;
    public maxWidth: number = 500;
    public addHidden = true;
    public loading = false;
    public search = '';
    public categoryFourthLevelCode: CategoryFourthLevel = new CategoryFourthLevel();

    public get categoryFourthLevelList() {
        return categoryFourthLevelModule.categories;
    }

    public get categoryThirdLevelList() {
        return categoryThirdLevelModule.categories;
    }

    public get columns() {
        return [
            { dataField: 'id', allowEditing: false },
            { dataField: 'code', caption: this.$tc('maestro-configuracion.codigo'), allowEditing: true },
            { dataField: 'description', caption: this.$tc('maestro-configuracion.descripcion'), allowEditing: true },
            {
                dataField: 'categoryThirdLevel.id', caption: this.$tc('maestro-configuracion.categoria-tercer-nivel'),
                lookup: {
                    dataSource: this.categoryThirdLevelList,
                    valueExpr: 'id',
                    displayExpr: 'code'
                }
            },
            { dataField: 'externalID', caption: this.$tc('maestro-configuracion.externalID'), allowEditing: false },
        ]
    }

    public async mounted() {
        await categoryFourthLevelModule.getCategoriesFourthLevel();
        await categoryThirdLevelModule.getCategoriesThirdLevel();
    }

    public async rowInserted(e: any) {
        if (e.data.categoryThirdLevel == undefined || e.data.categoryThirdLevel == null || e.data.categoryThirdLevel.id < 1) {
            await categoryFourthLevelModule.getCategoriesFourthLevel();
            itiMessageService.toast(this.$tc('mensajes.error-categoria-padre-vacia'), 'error', 2000);
        }
        else
            categoryFourthLevelModule.insertarCategoryFourthLevel(e.data);
    }

    public rowUpdated(e: any) {
        categoryFourthLevelModule.modificarCategoryFourthLevel(e.data);
    }

    public rowRemoved(e: any) {
        categoryFourthLevelModule.eliminarCategoryFourthLevel(e.key);
    }

    public initNewRow(e: any) {
        e.data.id = 0;
    }
}